var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCirclesBottomLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-598 -991)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#001847",
    strokeWidth: 3,
    transform: "translate(598 991)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#5f48e9",
    transform: "translate(606 999)"
  }))));
}

export default SvgCirclesBottomLeft;